import { ISubscription } from 'rxjs/Subscription';

class ServerServiceSubscriptionStore {
  private readonly subscriptionList: ISubscription[] = [];

  constructor(...subscriptions: ISubscription[]) {
    this.push(...subscriptions);
  }

  public push(...subscriptions: ISubscription[]): void {
    if (subscriptions && subscriptions.length > 0) {
      this.subscriptionList.push(...subscriptions.filter((subscription) => subscription !== null && subscription !== undefined));
    }
  }

  public unsubscribeAll() {
    this.subscriptionList.forEach((subscription) => subscription.unsubscribe());
    this.subscriptionList.splice(0);
  }
}

export { ServerServiceSubscriptionStore };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/server-service/server-service-subscription-store.ts